export default class ColorDetect {
    constructor(selector = '.js-color-detect', threshold = 128) {
        this.selector = selector;
        this.threshold = threshold;
        this.init();
    }

    init() {
        const images = document.querySelectorAll(this.selector);

        images.forEach((img) => {
            if (img.complete) {
                this.analyze(img);
            } else {
                img.addEventListener('load', () => this.analyze(img));
            }
        });
    }

    analyze(img) {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

            let r = 0, g = 0, b = 0, count = 0;

            for (let i = 0; i < imageData.length; i += 4 * 10) {
                r += imageData[i];
                g += imageData[i + 1];
                b += imageData[i + 2];
                count++;
            }

            r = r / count;
            g = g / count;
            b = b / count;

            const brightness = (r * 299 + g * 587 + b * 114) / 1000;

            const parent = img.closest('.post-item');
            if (!parent) return;

            parent.classList.remove('is-dark', 'is-light');
            // console.log('→ Brightness', brightness, '| Seuil :', this.threshold);
            parent.classList.add(brightness < this.threshold ? 'is-dark' : 'is-light');
            // console.log('→ Classe ajoutée :', brightness < this.threshold ? 'is-dark' : 'is-light');

        } catch (error) {
            console.warn('ColorDetect: erreur lors de l’analyse', img, error);
        }
    }
}
